import React from 'react'

import { Field } from 'formik'

import { Table, Form } from '_zari/core'

import { KeyEventUtil } from 'utils'

const CantidadCell = ({ row, dispatch, iError, iTouched, handleChange, autoFocus }) => {
  const onChange = React.useCallback(
    e => {
      handleChange(e)

      dispatch({
        type: 'actualizar',
        payload: {
          ...row,
          cantidad: e.target.value
        }
      })
    },
    [handleChange, dispatch, row]
  )

  const onKeyDown = React.useCallback(
    e => {
      KeyEventUtil.leaveOnEnterOrTab(`${row._idFila}-fechaRequerimiento`, e)
    },
    [row]
  )

  return (
    <Table.Cell>
      <Field name='cantidad'>
        {({ field }) => (
          <Form.InputText
            {...field}
            id={`${row._idFila}-cantidad`}
            isInvalid={iTouched && iError}
            onChange={onChange}
            onKeyDown={onKeyDown}
            autoFocus={autoFocus}
          />
        )}
      </Field>
    </Table.Cell>
  )
}

export default React.memo(CantidadCell)
